import React, { useEffect } from "react";
import { formatNumberCommas } from "../utils/formatNumberCommas";
import * as S from "../css/Dashboard.styles";
import MenuComponent from "../component/MenuComponent";
import WeekChart from "../component/dashboard/WeekChart";
import useGetAmount from "../api/dashboard/useGetAmount";
import YearChart from "../component/dashboard/YearChart";
import { useRecoilValue } from "recoil";
import { loginState } from "../stores/loginState";
import { todayState } from "../stores/dashboard/todayState";

function Dashboard(props) {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const todayData = useRecoilValue(todayState); // 오늘자 데이터 전역변수

  // TODO 스캔처리 건수, 차량운영 대수 불러오는 API
  const { mutate: getAmountMutate } = useGetAmount();

  // NOTE 일일 운영 현황 오늘날짜 표기
  const getFormattedDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 월은 0부터 시작하므로 1을 더해줍니다.
    const day = date.getDate();
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const dayOfWeek = days[date.getDay()]; // 요일을 가져옵니다.

    return `${year}.${month}.${day}(${dayOfWeek})`;
  };
  const formattedDate = getFormattedDate();

  // NOTE 페이지 로딩 시 스캔처리 건수, 차량운영대수 불러오기
  useEffect(() => {
    getAmountMutate();
  }, [getAmountMutate]);
  
  return (
    <S.DashboardContainer>
      <MenuComponent theme={props.theme} />
      <S.ContentContainer>
        <S.TitleContainer>
          <h1>
            {login.branchName}({login.branchCode}) 지점 운영 현황
          </h1>
        </S.TitleContainer>
        <S.FlexContainerTitle>
          
        <h2>일일 운영 현황 : {formattedDate}</h2>
        </S.FlexContainerTitle>
        <S.FlexContainer>
          <div>
            <S.ValueContainerBox>
              <div>
                <S.ValueContainerTitle>
                  <h4>스캔처리 건수</h4>
                  <hr />
                  <S.ValueContainerLine>
                    <S.ValueContainer>
                      <p>{login.company === "LOGEN" ? "배송입고" :
                       login.company === "LOTTE" ? "도 착" : "간선하차"}</p>
                      <span>
                        <h4>{formatNumberCommas(todayData.deliveryInTotal || 0)}</h4>
                        <p>건</p>
                      </span>
                    </S.ValueContainer>
                    <nav />
                    <S.ValueContainer>
                      <p>{login.company === "LOGEN" ? "집하출고" :
                       login.company === "LOTTE" ? "발 송" : "간선상차"}</p>
                      <span>
                        <h4>{formatNumberCommas(todayData.deliveryOutTotal || 0)}</h4>
                        <p>건</p>
                      </span>
                    </S.ValueContainer>
                    <nav />
                    <S.ValueContainer>
                      <p>합 계</p>
                      <span>
                        <h4>{formatNumberCommas(todayData.total || 0)}</h4>
                        <p>건</p>
                      </span>
                    </S.ValueContainer>
                  </S.ValueContainerLine>
                </S.ValueContainerTitle>
              </div>
              <div>
                <S.ValueContainerTitle>
                  <h4>차량운영대수</h4>

                  <hr />
                  <S.ValueContainerLine>
                    <S.ValueContainer>
                      <p>{login.company === "LOGEN" ? "배송입고" :
                       login.company === "LOTTE" ? "도 착" : "간선하차"}</p>
                      <span>
                        <h4>{formatNumberCommas(todayData.inVehicleCnt || 0)}</h4>
                        <p>개</p>
                      </span>
                    </S.ValueContainer>
                    <nav />
                    <S.ValueContainer>
                      <p>{login.company === "LOGEN" ? "집하출고" :
                       login.company === "LOTTE" ? "발 송" : "간선상차"}</p>
                      <span>
                        <h4>{formatNumberCommas(todayData.outVehicleCnt || 0)}</h4>
                        <p>개</p>
                      </span>
                    </S.ValueContainer>
                    <nav />
                    <S.ValueContainer>
                      <p>합계</p>
                      <span>
                        <h4>{formatNumberCommas(todayData.cntOfVehicle || 0)}</h4>
                        <p>개</p>
                      </span>
                    </S.ValueContainer>
                  </S.ValueContainerLine>
                </S.ValueContainerTitle>
              </div>
            </S.ValueContainerBox>
          </div>
          <div>
            <S.ChartContainerLine>
              <div>
                <S.ValueContainerTitle>
                  <h4>주간 운영현황</h4>
                  <hr />
                <S.ChartContainer>
                  <WeekChart theme={props.theme} />
                </S.ChartContainer>
                </S.ValueContainerTitle>
              </div>
              <div>
                <S.ValueContainerTitle>
                  <h4>월별 운영현황</h4>
                  <hr />
                <S.ChartContainer>
                  <YearChart theme={props.theme} />
                </S.ChartContainer>
                </S.ValueContainerTitle>
              </div>
            </S.ChartContainerLine>
          </div>
        </S.FlexContainer>
      </S.ContentContainer>
    </S.DashboardContainer>
  );
}

export default Dashboard;
